<script setup lang="ts">
import type { RsvpListFilters } from "./types"
import { onMounted, reactive, watchEffect } from "vue"
import { Drawer, Select, Switch } from "@/components/ui"
import { useTranslation } from "@/composables"
import { RsvpListFiltersDrawerKey } from "@/symbols"

interface RsvpListFiltersDrawerProps {
  filters: RsvpListFilters
}

const props = defineProps<RsvpListFiltersDrawerProps>()

const emit = defineEmits<{
  "update:filters": [filters: RsvpListFilters]
}>()

const filterDefaults: RsvpListFilters = {
  perPage: 50,
  showDietaryRequirements: undefined,
}

const internalFiltersState = reactive<RsvpListFilters>(structuredClone(filterDefaults))

onMounted(() => {
  if (props.filters?.perPage)
    internalFiltersState.perPage = props.filters.perPage
  if (props.filters?.showDietaryRequirements !== undefined)
    internalFiltersState.showDietaryRequirements = props.filters.showDietaryRequirements
})

const { t } = useTranslation()

const perPageOptions = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "15", value: 15 },
  { label: "25", value: 25 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
]

watchEffect(() => {
  emit("update:filters", internalFiltersState)
})
</script>

<template>
  <Drawer :name="RsvpListFiltersDrawerKey" :title="t('filter')">
    <form @submit.prevent>
      <div class="flex flex-col gap-4">
        <Switch
          id="showDietaryRequirements"
          v-model="internalFiltersState.showDietaryRequirements"
          name="showDietaryRequirements"
          :label="t('guest_list_filters_drawer.dietary_requirements_label')"
        />
        <Select
          v-model="internalFiltersState.perPage"
          name="perPage"
          :label="t('guest_list_filters_drawer.per_page_label')"
          :items="perPageOptions"
        />
      </div>
    </form>
  </Drawer>
</template>
